module.exports = __webpack_public_path__ + "static/media/clock-radio-filter.960cc617.jpeg";